import _extends from '@babel/runtime/helpers/extends';
import React from 'react';
import { string, func, shape, number } from 'prop-types';
import styles from './styles.module.css.js';

/* istanbul ignore next */
var defaultProps = {
  itemTitle: null,
  itemIcon: null,
  itemLink: null,
  itemValue: null,
  SVGIcon: null,
  handleClick: null,
  switchTabIndex: null,
  dataTestSuffix: ''
};
var propTypes = {
  itemTitle: string,
  itemIcon: string,
  itemLink: string,
  itemValue: string,
  SVGIcon: func,
  handleClick: func,
  switchTabIndex: shape({
    tabIndex: number
  }),
  dataTestSuffix: string
};
var ToggleDrawerList = function ToggleDrawerList(props) {
  var itemTitle = props.itemTitle,
    itemIcon = props.itemIcon,
    itemLink = props.itemLink,
    itemValue = props.itemValue,
    SVGIcon = props.SVGIcon,
    handleClick = props.handleClick,
    switchTabIndex = props.switchTabIndex,
    dataTestSuffix = props.dataTestSuffix;
  var formattedDataSuffix = dataTestSuffix ? "-".concat(dataTestSuffix) : '';
  return /*#__PURE__*/React.createElement("div", {
    className: styles.ToggleDrawerListItem,
    "data-test": "toggle-drawer-list".concat(formattedDataSuffix)
  }, /*#__PURE__*/React.createElement("span", {
    className: "tds-text--caption ".concat(styles['ToggleDrawerList--Title'])
  }, itemIcon ? /*#__PURE__*/React.createElement("i", {
    className: "tds-icon ".concat(itemIcon, " ").concat(styles['ToggleDrawerList--Icon']),
    "data-test": "toggle-drawer-list-icon".concat(formattedDataSuffix),
    "aria-hidden": "true"
  }) : null, SVGIcon ? /*#__PURE__*/React.createElement("div", {
    className: styles.ToggleDrawerListSvg,
    "data-test": "toggle-drawer-list-svg-icon".concat(formattedDataSuffix)
  }, /*#__PURE__*/React.createElement(SVGIcon, null)) : null, itemLink ? /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement("a", _extends({
    href: itemLink,
    className: "tds-link ".concat(styles.ToggleDrawerListButtonText),
    target: "_blank",
    rel: "noopener noreferrer",
    onClick: handleClick
  }, switchTabIndex, {
    "data-test": "toggle-drawer-list-link".concat(formattedDataSuffix)
    // eslint-disable-next-line react/no-danger
    ,
    dangerouslySetInnerHTML: {
      __html: itemTitle
    }
  }))) : /*#__PURE__*/React.createElement("div", {
    className: styles.ToggleDrawerListItemTitle,
    title: itemTitle,
    "data-test": "toggle-drawer-list-title".concat(formattedDataSuffix)
    // eslint-disable-next-line react/no-danger
    ,
    dangerouslySetInnerHTML: {
      __html: itemTitle
    }
  })), /*#__PURE__*/React.createElement("span", {
    className: "tds-text--caption",
    "data-test": "toggle-drawer-list-value".concat(formattedDataSuffix)
  }, itemValue));
};
ToggleDrawerList.propTypes = propTypes;
ToggleDrawerList.defaultProps = defaultProps;

export { ToggleDrawerList as default };
